/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unsafe-optional-chaining */
import React, { useState, useEffect, useRef } from 'react';
import {
  MdEditDocument,
  MdDeleteOutline,
  MdOutlineDocumentScanner,
} from 'react-icons/md';
import './AgentSeriesFare.scss';
import AppIconButton from '../../../shared/components/app-icon-button/AppIconButton';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';

import {
  getAgentCouponApi,
  getFlightDaywiseAvailRecord,
  deleteAgentSeriesFare,
} from '../../../api/profileApi';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppModal from '../../../shared/components/app-modal/AppModal';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import { debounce } from '../../../api/apiUtils';
import EditCoupon from './EditCoupon';
import DayWiseAvail from './DayWiseAvail';
import EditDayWiseAvail from './EditDayWiseAvail';
import AppButton from '../../../shared/components/app-button/AppButton';

function AgentSeriesFare() {
  const [couponsList, setCouponsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [searchText, setSearchText] = useState('');
  const allCouponsRef = useRef([]);
  const selectedEditCouponRef = useRef(undefined);
  const dayWiseAvailCouponRef = useRef(undefined);
  const editDayWiseAvailCouponRef = useRef(undefined);
  const couponForDeleteRef = useRef(undefined);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDayWiseAvailModal, setShowDayWiseAvailModal] = useState(false);
  const [editDayWiseAvailModal, setShowEditDayWiseAvailModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const getAgentCoupons = async () => {
    setIsLoading(true);
    const response = await getAgentCouponApi();
    if (response.Root?.Status === 'OK') {
      const { CouponMaster } = response.Root?.Result;
      const list = Array.isArray(CouponMaster) ? CouponMaster : [CouponMaster];
      allCouponsRef.current = list;
      setCouponsList(list);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getAgentCoupons();
  }, []);

  const handleFilter = debounce(() => {
    if (searchText !== '' && searchText !== null) {
      let data = [...allCouponsRef.current];
      data = data.filter((o) =>
        Object.keys(o).some(
          (k) =>
            o[k] !== null &&
            o[k] !== undefined &&
            o[k].toString().toLowerCase().includes(searchText.toLowerCase()),
        ),
      );
      setCouponsList(data);
    }
  }, 500);
  useEffect(() => {
    handleFilter();
  }, [searchText]);

  const handleShowEditModal = (coupon) => {
    selectedEditCouponRef.current = coupon;
    setShowEditModal(true);
  };

  const handleOpeDayWiseAvailModal = (id) => {
    dayWiseAvailCouponRef.current = id;
    setShowDayWiseAvailModal(true);
  };

  const getAvailDetailsForRecord = async (id) => {
    setIsLoading(true);
    const response = await getFlightDaywiseAvailRecord(id);
    if (response && response.Root?.Status === 'OK') {
      const { FlightDaywiseavail } = response.Root.Result;
      if (FlightDaywiseavail !== '') {
        editDayWiseAvailCouponRef.current = FlightDaywiseavail;
        setShowDayWiseAvailModal(false);
        setShowEditDayWiseAvailModal(true);
      } else {
        setAlert({
          variant: 'error',
          title: 'Flight Day Wise Avail',
          description: 'No records Available',
        });
      }
    }
    setIsLoading(false);
  };

  const handleEditFlightAvail = (id) => {
    getAvailDetailsForRecord(id);
  };

  const handleShowDeleteModal = (id) => {
    couponForDeleteRef.current = id;
    setShowDeleteModal(true);
  };

  const handleDeleteCoupon = async () => {
    setIsLoading(true);
    if (couponForDeleteRef.current !== undefined) {
      const res = await deleteAgentSeriesFare(couponForDeleteRef.current);
      if (res && res.Root?.Status === 'OK') {
        setAlert({
          variant: 'success',
          title: 'Delete coupon',
          description: 'Coupon deleted successfully',
        });
        setShowDeleteModal(false);
        getAgentCoupons();
      }
    }
    setIsLoading(false);
  };

  return (
    <section>
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => {
            setAlert(undefined);
          }}
        />
      )}
      <AppLoading isLoading={isLoading} />
      <div className="coupons-container p-1">
        <div className="p-3 filter-container">
          <AppTextInput
            label="search"
            name="search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <div className="overflow-auto table-responsive">
          {couponsList.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>CouponId</th>
                  <th>JDate</th>
                  <th>Carrier</th>
                  <th>FlightNo</th>
                  <th>DepTime</th>
                  <th>ArrTime</th>
                  <th>From-To</th>
                  <th>TotalSeats</th>
                  <th>AvailSeats</th>
                  <th>A BaseFare</th>
                  <th>C BaseFare</th>
                  <th>I BaseFare</th>
                  <th>Type</th>
                  <th>Total Amount</th>
                  <th>EndDate</th>
                  <th>Status</th>
                  <th>Edit</th>
                  <th>Delete</th>
                  <th>DayWise Avail</th>
                </tr>
              </thead>
              <tbody>
                {couponsList.map((coupon) => (
                  <tr key={coupon.Couponid}>
                    <td>{coupon.Couponid}</td>
                    <td>{coupon.ValidJdates}</td>
                    <td>{coupon.CarrierCode}</td>
                    <td>{coupon.FlightNumber}</td>
                    <td>{coupon.Deptime}</td>
                    <td>{coupon.Arrtime}</td>
                    <td>{`${coupon.CouponOrigin} to ${coupon.CouponDestination}`}</td>
                    <td>{coupon.TotalCoupons}</td>
                    <td>{coupon.AvailableCoupons}</td>
                    <td>{coupon.BaseFare.toFixed(1)}</td>
                    <td>{coupon.ChildBaseFare.toFixed(1)}</td>
                    <td>{coupon.InfantBaseFare.toFixed(1)}</td>
                    <td>{coupon.TotalAmount.toFixed(2)}</td>
                    <td>{coupon.CouponType}</td>
                    <td>{coupon.CouponValidity}</td>
                    <td>{coupon.Status}</td>
                    <td>
                      <AppIconButton
                        variant="transparent"
                        onClick={() => handleShowEditModal(coupon)}
                      >
                        <MdEditDocument />
                      </AppIconButton>
                    </td>
                    <td>
                      <AppIconButton
                        variant="transparent"
                        onClick={() => handleShowDeleteModal(coupon.Couponid)}
                      >
                        <MdDeleteOutline />
                      </AppIconButton>
                    </td>
                    <td>
                      <AppIconButton
                        variant="transparent"
                        onClick={() =>
                          handleOpeDayWiseAvailModal(coupon.Couponid)
                        }
                      >
                        <MdOutlineDocumentScanner />
                      </AppIconButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div> No Results Found</div>
          )}
        </div>
        {showEditModal && selectedEditCouponRef.current && (
          <AppModal
            modalTitle={`Edit Coupon ${selectedEditCouponRef.current.Couponid}`}
            onModalClose={() => setShowEditModal(false)}
            size="xl"
            showCloseButton
          >
            <EditCoupon coupon={selectedEditCouponRef.current} />
          </AppModal>
        )}
        {showDayWiseAvailModal && (
          <AppModal
            modalTitle={`Flight Day Wise Avails for coupon : ${dayWiseAvailCouponRef.current}`}
            onModalClose={() => setShowDayWiseAvailModal(false)}
            showCloseButton
            size="xl"
          >
            <DayWiseAvail
              coupoinId={dayWiseAvailCouponRef.current}
              onEdit={handleEditFlightAvail}
            />
          </AppModal>
        )}
        {editDayWiseAvailModal && (
          <AppModal
            modalTitle={`Edit Flight Daywise Avail ${editDayWiseAvailCouponRef.current.Recordid}`}
            showCloseButton
            onModalClose={() => setShowEditDayWiseAvailModal(false)}
          >
            <EditDayWiseAvail />
          </AppModal>
        )}
        {showDeleteModal && (
          <AppModal
            modalTitle="Delete Coupon"
            showCloseButton
            onModalClose={() => setShowDeleteModal(false)}
          >
            <div>
              <p>
                Are you sure You want to delete Coupon :{' '}
                {couponForDeleteRef.current}
              </p>
              <div className="d-flex justify-content-end gap-2">
                <AppButton
                  variant="red"
                  btnText="Delete"
                  onClick={handleDeleteCoupon}
                />
                <AppButton
                  variant="outlined"
                  btnText="Delete"
                  onClick={() => setShowDeleteModal(false)}
                />
              </div>
            </div>
          </AppModal>
        )}
      </div>
    </section>
  );
}

export default AgentSeriesFare;
